
//Components
import AContact from "../components/AContact.js"
import InfoMarcas from "../components/InfoMarcas.js"
import Navbar from "../components/Navbar.js"

export default function Marcas () {

    return (
        <div>
            <AContact />
            <Navbar />
            <InfoMarcas />
        </div>
    )
}